<template>
  <UnSwitcherNew
    ref="switcher"
    :hasHead="false"
    :hasOpener="false"
    :swKey="street === 'flop' ? 'sw_reports_flop_content' : 'sw_reports_turn_content'"
    tstPrefix="rprts_sw"
  >
    <template #item_after="{ item }">
      <UnSwitcherNew
        v-if="item.payload.includes('table')"
        class="ml-1 z-index_4"
        swKey="sw_reports_colorcoding01"
        style="--uns-opener-clr-back: rgba(255, 255, 255, 0.075)"
        placement="bottom"
        :isInside="true"
        :hasOpener="false"
      />
    </template>

    <template #menu_after>
      <div class="bt-grey my-1"></div>
      <div
        class="z-index_0 gw_btn no-events gw_btn_text gw_btn_small clr-grey text-medium f-justify-start bt-grey"
        style="--padding: 0.375rem"
      >
        <span class="keyboardkey_key">
          {{ $store.getters.hotkeys.study_reports_turn_view.displayCombination }}
        </span>
        <span
          class="keyboardkey_note"
          v-html="$t('hotkeys.turn_reports.to_switch')"
        ></span>
      </div>
    </template>
  </UnSwitcherNew>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'

export default {
  name: 'ReportsViewSwitcher',
  components: {
    UnSwitcherNew,
  },
  props: {
    street: { default: () => 'flop' },
  },
  computed: {
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
  },
  watch: {
    hotkeysPressed(keys) {
      if (!keys) return
      const hotkeyActions = {
        reports_content_switch: {
          keys: this.hotkeys.study_reports_turn_view.keyCombination,
          fn: () => {
            if (this.$refs.switcher) {
              this.$store.dispatch('hotkeys_reset')
              this.$refs.switcher.toggleThreeWay()
            }
          },
        },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
}
</script>
